export default {
  dark: "Theme Dark",
  light: "Theme Light",
  metric: "Metric",
  imperial: "Imperial"
};
